// src/components/layout/Header.js
import React from 'react';
import { Navbar, Nav, NavDropdown, Button, Container,Image  } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { useSettings } from '../../contexts/SettingsContext';
import { useTranslation } from 'react-i18next';
// Import icons for hamburger menu
import { FaUserCircle, FaBars, FaSignOutAlt, FaSun, FaMoon } from 'react-icons/fa'; // Added Logout, Theme icons
import '../../styles/Header.css'; // Import custom CSS

// Accept toggleSidebar and isSidebarVisible as props
const Header = ({ toggleSidebar, isSidebarVisible }) => {
    const { t } = useTranslation();
    const { user, logout } = useAuth();
    const { language, currency, changeLanguage, changeCurrency } = useSettings();

    const handleLanguageChange = (lng) => {
        changeLanguage(lng);
    };

    const handleCurrencyChange = (curr) => {
        changeCurrency(curr);
    };

    return (
        // Added position-sticky and top-0 for potential fixed header later
        <Navbar bg="light" expand="lg" className="border-bottom shadow-sm header-navbar position-sticky top-0" style={{ zIndex: 1030 }}>
            <Container fluid>
                {/* Hamburger Menu Button */}
                <Button
                    variant="outline-secondary"
                    onClick={toggleSidebar} // Call the toggle function passed from MainLayout
                    className="me-2" // Margin end for spacing
                    aria-label={isSidebarVisible ? "Hide sidebar" : "Show sidebar"} // Accessibility
                >
                    <FaBars />
                </Button>

                {/* AppName or other brand element if needed */}
                {/* <Navbar.Brand href="/dashboard">{t('appName')}</Navbar.Brand> */}

                {/* Keep the original Navbar.Toggle for collapsing dropdowns on small screens */}
                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-center">
                        {/* Language Selector */}
                        <NavDropdown title={<>{language.toUpperCase()} <i className="bi bi-translate ms-1"></i></>} id="language-dropdown" align="end" className="me-2">
                            <NavDropdown.Item active={language === 'en'} onClick={() => handleLanguageChange('en')}>English</NavDropdown.Item>
                            <NavDropdown.Item active={language === 'ar'} onClick={() => handleLanguageChange('ar')}>العربية</NavDropdown.Item>
                        </NavDropdown>

                        {/* Currency Selector */}
                       {/*  <NavDropdown title={<>{currency} <i className="bi bi-currency-dollar ms-1"></i></>} id="currency-dropdown" align="end" className="me-3">
                            <NavDropdown.Item active={currency === 'INR'} onClick={() => handleCurrencyChange('INR')}>INR (₹)</NavDropdown.Item>
                            <NavDropdown.Item active={currency === 'SAR'} onClick={() => handleCurrencyChange('SAR')}>SAR (﷼)</NavDropdown.Item>
                        </NavDropdown> */}

                        {/* User Dropdown */}
                        {user && (
                            <NavDropdown
                                title={
                                    <>
                                        <img src="/placeholder-avatar.png" alt={t('appName')} width="30" height="30" className="me-2"/> 
                                        {/* <FaUserCircle size={20} className="me-1" /> */}
                                        {user.username} ({t(user.role.toLowerCase()) || user.role}) {/* Translate role */}
                                    </>
                                }
                                id="user-dropdown"
                                align="end"
                            >
                                <NavDropdown.Item as={Button} variant="link" onClick={logout} className="text-danger dropdown-item"> {/* Ensure dropdown-item class */}
                                    {t('logout')}
                                </NavDropdown.Item>
                            </NavDropdown>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;